var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLegal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_legal",
    transform: "translate(-158.8 -132.08)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48571",
    "data-name": "Path 48571",
    d: "M170.932,150.373v-1.026H161.8v1.03a1.8,1.8,0,0,0,1.871,1.7h8.18c-.075-.064-.154-.12-.225-.185a2.046,2.046,0,0,1-.7-1.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48573",
    "data-name": "Path 48573",
    d: "M178.544,136.589h-.008a1.288,1.288,0,0,0-1.276,1.274v2.166H179.8v-2.171A1.266,1.266,0,0,0,178.544,136.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48595",
    "data-name": "Path 48595",
    d: "M166.03,136.08a1.345,1.345,0,0,0-1.35,1.338l-.079,10.854h7.385a.28.28,0,0,1,.268.282v1.483a2.032,2.032,0,0,0,2.012,2.042h.007a2.019,2.019,0,0,0,2-2.036V137.535a2.063,2.063,0,0,1,.634-1.455Zm4.4,10.182a4,4,0,1,1,4.125-4,4.064,4.064,0,0,1-4.125,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48693",
    "data-name": "Path 48693",
    d: "M172.6,140.767a.578.578,0,0,0-.8,0l-1.805,1.75-.892-1.081a.586.586,0,0,0-.817-.07.554.554,0,0,0-.072.779l1.287,1.564a.583.583,0,0,0,.425.207h.023a.577.577,0,0,0,.4-.162l2.28-2.213A.551.551,0,0,0,172.6,140.767Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLegal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_legal.bb80cda86a0992a7c6ca883ba5935a68.svg";